var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"plaaybackVideoBox",staticClass:"video_box",attrs:{"element-loading-background":"rgba(0, 0, 0, 0.2)"}},[_c('div',{staticClass:"plaaybackVideo",style:({
      height: _vm.plaaybackVideoHeight + 'px',
      width: _vm.plaaybackVideoWidth + 'px',
    }),attrs:{"id":`plaaybackVideo`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }